export enum QueryKeys {
  APP_NAV = "app_nav",
  FETCH_TRANSLATIONS = "fetch_translations",
  FETCH_FACET_OPTIONS = "fetch_facet_options",
  FETCH_PRODUCTION_TYPES = "fetch_production_types",
  FETCH_AGENCIES = "fetch_agencies",
  FETCH_QUALIFICATION_LEVELS = "fetch_qualification_levels",
  FETCH_PRESIGNED_OBJECT = "fetch_presigned_object",
  FETCH_MARKETING_PREFERENCES = "fetch_marketing_preferences",
  FETCH_PERFORMER_TYPE_OPTIONS = "fetch_performer_type_options",
  FETCH_LOOKUP = "fetch_lookup",
  FETCH_CD_APPLICATION = "fetch_cd application",
}
